import { render } from "./Elevator.vue?vue&type=template&id=147f5812&scoped=true"
import script from "./Elevator.vue?vue&type=script&lang=js"
export * from "./Elevator.vue?vue&type=script&lang=js"

import "./Elevator.vue?vue&type=style&index=0&id=147f5812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147f5812"]])

export default __exports__